// packages/shared/api-client/config.js
// Configuration for API client shared across web and mobile

/**
 * Get API base URL based on environment
 * @returns {string}
 */
export function getApiUrl() {
  // Browser environment (React web)
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    return process.env.REACT_APP_API_URL || 'http://localhost:3000';
  }

  // React Native / Expo environment
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    // In Expo, environment variables are accessed differently
    // They're bundled at build time and available via process.env
    const apiUrl = process.env.EXPO_PUBLIC_API_URL;

    console.log('[Config] React Native detected');
    console.log('[Config] EXPO_PUBLIC_API_URL:', apiUrl);
    console.log('[Config] All env vars:', Object.keys(process.env));

    return apiUrl || 'http://localhost:5000';
  }

  // Default fallback
  return 'http://localhost:3000';
}

/**
 * Create headers for API requests
 * @param {string|null} token - JWT access token
 * @returns {object}
 */
export function createHeaders(token = null) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
}

